module.exports = __webpack_public_path__ + "static/media/LOGO (3).84b95184.svg";